<template>
  <!-- десктоп -->
  <aside v-if="!isMobile" class="sidebar-container" :style="{ width: isShort ? '60px' : '300px' }">
    <section class="main-section" @click="setBurgerMenu">
      <slot name="main" :is-short="isShort" />
    </section>
    <section class="additional-section">
      <slot name="additional" :is-short="isShort" :toggle="toggle" />
    </section>
  </aside>

  <!-- мобильный -->
  <Teleport to="body">
    <div
      v-if="isMobile && isBurgerMenuOpen && landing"
      class="mobile-scrim landing"
      @click="setBurgerMenu"
    ></div>
    <aside
      v-if="isMobile && isBurgerMenuOpen"
      class="mobile-view"
      :class="{ landing }"
      :style="{ width: isShort ? '60px' : '220px' }"
    >
      <div class="sidebar-container">
        <section class="main-section" @click="setBurgerMenu">
          <slot name="main" :is-short="isShort" />
        </section>
        <section class="additional-section">
          <slot name="additional" :is-short="isShort" :toggle="toggle" />
        </section>
      </div>
    </aside>
  </Teleport>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    landing: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const isShort = ref(true);

    const isMobile = computed(() => store.getters['mobile/breakPoint'] === 'mobile');
    const isBurgerMenuOpen = computed(() => store.getters['burgerMenu/isOpen']);
    const toggle = () => {
      isShort.value = !isShort.value;
    };

    const setBurgerMenu = () => {
      if (isMobile.value) {
        store.dispatch('burgerMenu/setBurger', { isOpen: false });
      }
    };

    watch(
      () => store.getters['mobile/breakPoint'],
      (breakPoint) => {
        isShort.value = breakPoint !== 'mobile';
      },
      { immediate: true }
    );

    return {
      isMobile,
      isShort,
      toggle,
      isBurgerMenuOpen,
      setBurgerMenu,
    };
  },
});
</script>
<style scoped lang="scss">
.sidebar-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: space-between;

  /* Разные фоны для мобильной и десктопной версий */
  background: rgba(255, 255, 255, 0.2); /* Дефолт для десктопа */

  /* Эффект матового стекла для десктопа */
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); /* для Safari */

  border-right: 1px solid rgba(255, 255, 255, 0.3);
  padding: 15px;
  height: calc(100dvh - var(--header-height));

  & .main-section {
    cursor: pointer;
    max-height: 70vh;
    overflow-y: auto;
    /* Скрыть скроллбар в разных браузерах */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE и Edge */

    &::-webkit-scrollbar {
      /* Chrome, Safari, Opera */
      display: none;
    }
  }

  & .additional-section {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 2rem;
  }
}

/* Для мобильной версии меняем фон */
.mobile-view .sidebar-container {
  background: var(--color-bg); /* Сплошной фон для мобильной версии */
  backdrop-filter: none; /* Отключаем размытие если нужен сплошной фон */
  -webkit-backdrop-filter: none;
}

.mobile-view {
  position: fixed;
  width: 100% !important;
  z-index: 9;
  bottom: 0;
  top: var(--header-height);

  background: rgba(var(--color-bg-rgb), 0.95);
}

.mobile-scrim.landing {
  position: fixed;
  inset: 56px 0 0;
  z-index: 8;
  background: rgba(8, 6, 12, 0.42);
}

.mobile-view.landing {
  top: 56px;
  z-index: 9;
  background: rgba(20, 16, 24, 0.92);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-top: 1px solid rgba(246, 243, 238, 0.08);
}

.mobile-view.landing .sidebar-container {
  height: 100%;
  padding: 18px 18px 28px;
  background: transparent;
  border-right: 0;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.mobile-view.landing :deep(.sidebar-item) {
  gap: 12px;
  margin: 0 0 8px;
  padding: 12px 14px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 16px;
  background: rgba(20, 16, 24, 0.28);
  color: #f6f3ee;
  font-size: 14px;
  letter-spacing: 0.02em;
}

.mobile-view.landing :deep(.sidebar-item:hover) {
  color: #fff;
  border-color: rgba(246, 243, 238, 0.32);
  background: rgba(246, 243, 238, 0.08);
}

.mobile-view.landing :deep(.active-link .sidebar-item) {
  color: #141018;
  border-color: transparent;
  background: #f6f3ee;
}
</style>
